import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHorizontalAlignmentBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"horizontal-alignment-bottom"} maskId="square-filled-radius-0-stroke-1-IconHorizontalAlignmentBottom"><path d="M6 3V18H11V3H6Z" fill="currentColor"/><path d="M13 7V18H18V7H13Z" fill="currentColor"/><path d="M3 20V21H21V20H3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconHorizontalAlignmentBottom;
